import {
  splitProps,
  For as SolidFor,
  Show as SolidShow,
  Index as SolidIndex,
  Switch as SolidSwitch,
  Suspense as SolidSuspense,
  JSX,
} from 'solid-js';
import { Portal as SolidPortal } from 'solid-js/web';
import { createRootPool } from '@solid-primitives/rootless';

import { Toggle as ToggleDefault } from '../Toggle';
import { presenceify, Presence } from './transition';

export const For = presenceify(SolidFor);
export const Index = presenceify(SolidIndex);
export const Switch = presenceify(SolidSwitch);
export const Show = presenceify(SolidShow);
export const Toggle = presenceify(ToggleDefault);

/**
 * 经过动画修复后的Suspense, 默认不导出，可能会有Bug
 * fallback在连续动画时会有bug, 应该缓存fallback,让它在多个动画间可以正确过渡
 */
export const Suspense = presenceify((props: { fallback?: JSX.Element; children: JSX.Element }) => {
  const [active, setActive] = createSignal(true);
  const fallbackPool = createRootPool(() => {
    return <ActiveProvider value={!active()}>{props.fallback}</ActiveProvider>;
  });
  function fallback() {
    setActive(false);
    onCleanup(() => {
      // console.log(sharedConfig.context)
      setActive(true);
    });
    return fallbackPool();
  }
  return (
    <SolidSuspense fallback={fallback()}>
      <ActiveProvider value={active()}>{props.children}</ActiveProvider>
    </SolidSuspense>
  );
});

export { Presence };

function PortalCom(props: any) {
  const [, others] = splitProps(props, ['children']);
  return (
    <SolidPortal {...others}>
      <Presence>{props.children}</Presence>
    </SolidPortal>
  );
}

export const Portal = PortalCom as typeof SolidPortal;
// export const Suspense = presenceify(SolidSuspense);
// export const ErrorBoundary = presenceify(SolidErrorBoundary);
